import { Pipe, PipeTransform, NgModule } from '@angular/core';

@Pipe({
    name: 'itemDataFilter'
})
export class ItemDataPipe implements PipeTransform {
    transform(items: Array<any>, itemCode: number): Array<any> {
        return items.filter(item => item.itemId === itemCode);

    }
}

@NgModule({
    imports: [],
    declarations: [ItemDataPipe],
    exports: [ItemDataPipe]
})
export class ItemDataPipeModule { }